export default "__VITE_ASSET__860b7e49__"